export const MOBILE_BREAKPOINT = 768

export const HEADER_HEIGHT = 122

export const HEADER_HEIGHT_SMALL = 84

export const PROJECT_INFO_HEIGHT = 130

export const THUMBS_AND_INFO_MIN_HEIGHT = 230

export const VIDEO_SIDE_MARGIN = 20

export const VIDEO_MAX_WIDTH = 1920

export const PHOTOS_MAX_WIDTH = 1200

export const PHOTOS_COL_COUNT = 3

export const PHOTOS_GUTTER_WIDTH = 10

export const LIGHTBOX_MAX_WIDTH = 0.8

export const LIGHTBOX_MAX_HEIGHT = 0.8



// WEBPACK FOOTER //
// ./src/constants.js